import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COACHING_LINKS, PROGRAMS } from "@/data/coaching";
import { fadeUp } from "@/lib/motion";

const Program = ({ p, index }) => (
  <motion.article
    id={p.id}
    data-testid={`program-card-${p.id}`}
    {...fadeUp}
    className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-16 ${index % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}
  >
    <div className="overflow-hidden border border-navy/10 bg-white">
      <img src={p.image} alt={p.title} className="aspect-[4/3] w-full object-cover" />
    </div>
    <div>
      <div className="flex items-start gap-4">
        <p className="font-heading text-xl font-bold leading-[1.15] text-navy sm:text-2xl">{p.number}.</p>
        <h3 className="font-heading text-xl font-bold leading-[1.15] tracking-tight text-ink sm:text-2xl">{p.title}</h3>
      </div>
      <p className="mt-3 text-base text-ink/65">{p.audience}</p>
      <p className="mt-4 text-base leading-relaxed text-ink/70">
        {p.summary}
        {p.values && (
          <>
            {" "}
            {p.values.map((v, i) => (
              <span key={v}>
                <strong className="font-heading font-bold text-navy">{v}</strong>
                {i < p.values.length - 1 ? ", " : ". "}
              </span>
            ))}
            {p.summaryAfter}
          </>
        )}
      </p>
      <ul className="mt-6 grid gap-2.5">
        {p.includes.map((x) => (
          <li key={x} className="flex items-start gap-3 text-sm text-ink/80 sm:text-base">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center bg-azure/10 text-azure"><Check className="h-3 w-3" /></span>
            {x}
          </li>
        ))}
      </ul>
      <Button asChild data-testid={`program-cta-${p.id}`} className="btn-primary mt-8 h-12 px-6">
        <a href={COACHING_LINKS.calendly} target="_blank" rel="noopener noreferrer">I'm ready, Kelly <ArrowUpRight className="ml-1.5 h-4 w-4" /></a>
      </Button>
    </div>
  </motion.article>
);

export const Programs = () => (
  <section id="work-with-kelly" data-testid="programs-section" className="scroll-mt-24 bg-snow py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl text-ink">Work With Kelly</h2>
        <p className="mt-4 font-heading text-lg font-semibold sm:text-xl text-navy">Three ways to work with Kelly, one-on-one and alongside other women in leadership.</p>
        <p className="mt-5 text-base leading-relaxed text-ink/65 sm:text-lg">
          This is me, personally, not a hand-off to my team. Find your voice, step into leadership, and build a life that works for you.
        </p>
      </div>
      <div className="mt-14 flex flex-col gap-16">
        {PROGRAMS.map((p, i) => <Program key={p.id} p={p} index={i} />)}
      </div>
    </div>
  </section>
);
